// src/theme.js
//
// Theme is stored on <html> as a class so Tailwind's darkMode: "class" picks
// it up. The initial value is set by an inline script in public/index.html
// before first paint - doing it here instead would flash the wrong theme on
// every load.

import { useCallback, useEffect, useState } from "react";

const KEY = "bk-theme";

export function useTheme() {
  const [theme, setTheme] = useState(() =>
    document.documentElement.classList.contains("dark") ? "dark" : "light"
  );

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      // private browsing, ignore
    }
  }, [theme]);

  // Follow the OS only while the visitor has not made a choice of their own.
  useEffect(() => {
    let stored = null;
    try {
      stored = localStorage.getItem(KEY);
    } catch {
      // ignore
    }
    if (stored) return;

    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = (e) => setTheme(e.matches ? "dark" : "light");
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);

  const toggle = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  return { theme, toggle };
}